import { Suspense } from 'react';
import { Grid } from '@mui/joy';
import type { ReactElement } from 'react';
import { useAccountsSuspenseQuery } from 'generated/graphql';
import { venues } from '../../../venue/VenueData.tsx';
import GridCard from 'components/technical/GCard/GridCard.tsx';
import AccountCard from '../AccountCard.tsx';
import WithDialog from 'components/technical/inputs/withDialogHoc/WithDialog.tsx';
import { AccountType as AccountTypeEnum } from '../AccountService.tsx';
import { ADD_NEW_CARD_STYLE } from 'components/technical/GCard/consts.ts';
import { useAuth } from 'components/management/NewAuthProvider';
import { CreateAccountDialog } from '../createAccount/CreateAccountDialog.tsx';
import Loader from 'components/technical/Loader/Loader.tsx';
import { cardHeight, gridWidth } from './accountTab.utils.ts';

const GCardWithDialog = WithDialog(GridCard);

const CexCustodiansTab = (): ReactElement => {
  const { data } = useAccountsSuspenseQuery();
  const { isAdmin } = useAuth();

  const cEXsCustodiansAccounts = data.portfolio.accounts.filter(
    (account) => venues[account.venue.label]?.type === 'cex'
  );

  return (
    <Grid container spacing={3}>
      {isAdmin && (
        <GCardWithDialog
          cardSx={ADD_NEW_CARD_STYLE}
          renderDialog={({ onClose }): ReactElement => (
            <CreateAccountDialog onConnected={onClose} onClose={onClose} accountsType={AccountTypeEnum.Custodian} />
          )}
          height={cardHeight}
          gridWidth={gridWidth}
          addNewText="Add new account"
        />
      )}
      {cEXsCustodiansAccounts.map((account) => (
        <AccountCard key={account.id} account={account} gridWidth={gridWidth} height={cardHeight} />
      ))}
    </Grid>
  );
};

const CexCustodiansTabContainer = (): ReactElement => {
  return (
    <Suspense fallback={<Loader />}>
      <CexCustodiansTab />
    </Suspense>
  );
};

export default CexCustodiansTabContainer;
